import { render, staticRenderFns } from "./CommentListTable.vue?vue&type=template&id=cad0cad8&scoped=true"
import script from "./CommentListTable.vue?vue&type=script&lang=js"
export * from "./CommentListTable.vue?vue&type=script&lang=js"
import style0 from "./CommentListTable.vue?vue&type=style&index=0&id=cad0cad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad0cad8",
  null
  
)

export default component.exports